import { useState } from 'react';

import { Avatar } from 'antd';

import defaultAvatarImg from '@/lib/assets/default-avatar.jpg';
// import { GOOGLE_STORAGE_URL } from "@config/envs";
import prepareImageSrc from '@/lib/helpers/prepareImageSrc';

export default function CreatorAvatar({
	record,
	isNotRecord = false,
}: {
	record: any;
	isNotRecord?: boolean;
}) {
	const [src, setSrc] = useState<string | null>(
		prepareImageSrc(isNotRecord ? record : record?.profileImageURL) ??
			defaultAvatarImg,
	);

	if (isNotRecord) {
		return (
			<Avatar
				src={
					<img
						src={src!}
						alt={record}
						style={{ minWidth: '32px', maxWidth: '32px', maxHeight: '32px' }}
						onError={() => {
							setSrc(defaultAvatarImg);
						}}
					/>
				}
				alt={'image'}
				size={'large'}
				style={{ minWidth: '32px', maxWidth: '32px', maxHeight: '32px' }}
			></Avatar>
		);
	}

	return (
		<Avatar
			src={
				<img
					src={src!}
					alt={record?.profileName}
					style={{ minWidth: '38px' }}
					onError={() => {
						setSrc(defaultAvatarImg);
					}}
				/>
			}
			alt={record?.profileName}
			size={'large'}
			style={{ minWidth: '38px' }}
		></Avatar>
	);
}
